import React, { useEffect } from "react";
import "./Accueil.css";
import galaxie from "../../assets/images/galaxie.png";
import AboutUs from "../Accueil/AboutUs";
import teamImage from "../../assets/images/teamImage.jpg";
import CultureInnovation from "../Accueil/CultureInovation";
import Button from "../../components/Button/Button";
//import Metier from './Metier'
const Accueil = () => {
  useEffect(() => {
    const sections = document.querySelectorAll(".fade-in-section");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <div>
      <div className="accueil-container">
        <div className="fade-in-section texte-haut">
          <span className="hoag">Hoag Target</span> -{" "}
          <span className="highlight">Accélérateur d’innovation, de</span>
          <br />
          transformation digitale et d’employabilité
        </div>
        <div className="fade-in-section texte-bas">
          à l’échelle mondiale depuis Madagascar.
        </div>

        <div className="courbe-deco">
          <img src={galaxie} alt="courbe décorative" className="courbe-img" />
        </div>
      </div>
      <Button />
      <AboutUs />
      <CultureInnovation />
      {/* <Metier /> */}
    </div>
  );
};

export default Accueil;
